export const GET_ALL_CURRENCY = 'GET_ALL_CURRENCY';
export const GET_ALL_CURRENCY_SUCCESS = 'GET_ALL_CURRENCY_SUCCESS';
export const GET_ALL_CURRENCY_ERROR = 'GET_ALL_CURRENCY_ERROR';
export const GET_SINGLE_CURRENCY = 'GET_SINGLE_CURRENCY';
export const GET_SINGLE_CURRENCY_SUCCESS = 'GET_SINGLE_CURRENCY_SUCCESS';
export const GET_SINGLE_CURRENCY_ERROR = 'GET_SINGLE_CURRENCY_ERROR';
export const CREATE_CURRENCY = 'CREATE_CURRENCY';
export const CREATE_CURRENCY_SUCCESS = 'CREATE_CURRENCY_SUCCESS';
export const CREATE_CURRENCY_ERROR = 'CREATE_CURRENCY_ERROR';
export const UPDATE_CURRENCY = 'UPDATE_CURRENCY';
export const UPDATE_CURRENCY_SUCCESS = 'UPDATE_CURRENCY_SUCCESS';
export const UPDATE_CURRENCY_ERROR = 'UPDATE_CURRENCY_ERROR';
export const DELETE_CURRENCY = 'DELETE_CURRENCY';
export const DELETE_CURRENCY_SUCCESS = 'DELETE_CURRENCY_SUCCESS';
export const DELETE_CURRENCY_ERROR = 'DELETE_CURRENCY_ERROR';
